import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";
import Typography from "@mui/material/Typography";
import { Link as RouterLink } from "react-router-dom";

export function Home() {
  return (
      <>
          <AuthenticatedTemplate>
            <ButtonGroup orientation="vertical">
              <Button component={RouterLink} to="/profile" variant="contained" color="primary">My Info</Button>
              <Button component={RouterLink} to="/directory" variant="contained" color="primary">Directory</Button>
              <Button component={RouterLink} to="/orgchart/" variant="contained" color="primary">Org Chart</Button>
            </ButtonGroup>
          </AuthenticatedTemplate>

          <UnauthenticatedTemplate>
            <Typography variant="h6">
              <center>Please sign-in.</center>
            </Typography>
          </UnauthenticatedTemplate>
      </>
  );
}